<template>
    <div class="main">
        <c-panel>
            <form-paee :paramId="$route.params.id" v-on:onSubmit="onSubmit"></form-paee>
        </c-panel>
    </div>
</template>

<script>
import formPaee from './form'

export default {
    methods: {
        onSubmit () {
            this.$router.push('/admin/pedagogico/paee')
        }
    },
    components: { formPaee }
}
</script>
